import { render, staticRenderFns } from "./PdfTemplateImagesTable.vue?vue&type=template&id=6b54c4dc&scoped=true&"
import script from "./PdfTemplateImagesTable.vue?vue&type=script&lang=js&"
export * from "./PdfTemplateImagesTable.vue?vue&type=script&lang=js&"
import style0 from "./PdfTemplateImagesTable.vue?vue&type=style&index=0&id=6b54c4dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b54c4dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
